<template>
	<div class="w-100 stepAreaMain">
		<div class="middleBox mt-0"> 
			<div class="whiteBG p-3 Step-Form my-2 my-md-5">
			<div class="stepForm"> 
				<div class="row" v-if="test_failed == -1">
					<div class="col-12 mobPad">
						<h4 class="title mob-center pb-3 border-bottom text-left mb-4">{{$t('reg_step_three')}}</h4>
					</div>
					<div class="col-12 mobPad text-center">
						<div class="icon mb-5">
							<img src="../../../../static/fxView/images/test.svg" alt="Email Support" width="220">
						</div>
						<p class="mb-3">{{$t('reg_step_three_point')}}</p>
						<div class="row">
							<div class="col-12">
								<div class="full-width border-top pt-3  mt-3 w-100">
									<button class="prism_btn btn_sm" v-on:click.prevent="test_failed = 0; startTestEvent()">Start Test</button>
								</div>
							</div>
						</div>
					</div> 
				</div> 
				<div class="row" v-if="test_failed == 0">
					<div style="display: none;">{{ques_ans_array}}</div>
					<div class="col-12 mobPad question_answer" v-for="(val, key, i) in question_answer_key_array" v-if="i >= (page - 1)*limit && i < page*limit">
					<!-- v-if="show_question == i" -->
						<div>
							<div class="d-flex align-items-center justify-content-between pb-3 border-bottom text-left mb-3">
								<h4 class="title px-0">{{i+1}}. {{val.type}}</h4>
								<!-- <p class="qusNo mb-0">{{i+1}} Of {{Object.keys(question_answer_key_array).length}}</p> -->
							</div>
							<!--loader - message--->
							<complete-loading :pageloader_value="pageLoader" :type="'complete'" v-if="pageLoader"></complete-loading>
							<message-component :message="response_msg" :messageType="msg_type" v-if="response_msg != ''"></message-component>
						</div>
						<h5 class="subtitle text-left">{{val.question}}</h5>
						<ul class="twoColumn mb-4">
							<li v-for="ans_list in val.answers"><!--  :class="classFunction(key, ans_list.ans_id)" -->
								<label class="customRadio-button">{{ans_list.answer}}
									<input
										type="radio"
										class="form-control"
										:id="'ques-'+val.question_id"
										:name="'ques '+val.question_id"
										:value="ans_list.ans_id.toString()"
										:class="{ 'is-invalid': submitted && errors.has('ques '+val.question_id) }"
										:disabled="disable"
										v-model="ques_ans_array[key.toString()]"
										v-validate="'required'"
										@focus="trackFzEvent(val.sequence)"
									>
									<span class="checkmark"></span>
								</label>
							</li>
							<p class="text-danger" v-if="errors.has('ques '+val.question_id)">{{errors.first('ques '+val.question_id).replace('ques '+val.question_id,'Question '+(i+1))}}</p>
						</ul>
						<div class="row">
							<!-- <div class="quesPercntBar col-12 mb-3" v-show="false">
								<span>{{progress_bar}}% Complete</span>
								<div class="progressBar progress">
									<div class="progress-bar" role="progressbar" v-bind:style="{ width: incWidth + '%' }"  aria-valuenow="15" aria-valuemin="0" aria-valuemax="100"></div>
								</div>
							</div> -->
							<div class="col-12" v-if="false">
								<div class="full-width border-top submitButton align-items-center d-flex spacebetween mt-3 w-100">
									<div class="leftbtn">
										<!-- <button class="prism_btn btn_sm grayBtn" v-on:click.prevent="show_question -= 1" v-if="show_question > 1">Previous Question</button> -->
										<!-- <a href="#"  v-on:click.prevent="$parent.do_later = true" v-else>I'll do it later</a> -->
									</div> 
									<button class="prism_btn btn_sm" v-on:click.prevent="quesNext(key)" v-if="show_question < Object.keys(question_answer_key_array).length - 1">Next Question</button> 
									<button class="prism_btn btn_sm" v-on:click.prevent=" submit()" v-if="show_question ==  Object.keys(question_answer_key_array).length - 1">Save & Continue</button>
								</div>
							</div>
						</div>
					</div>
					<div class="col-12">
						<div class="full-width border-top pt-3 submitButton align-items-center d-flex spacebetween mt-3 w-100">
							<div class="leftbtn">
								<button class="prism_btn btn_sm grayBtn" v-on:click.prevent="page -= 1; trackPrevEvent()" v-if="page == 2">Previous Question</button>
								<!-- <a href="#"  v-on:click.prevent="$parent.do_later = true" v-else>I'll do it later</a> -->
							</div> 
							<button class="prism_btn btn_sm" v-on:click.prevent="quesNext(key)" v-if="page*limit <  Object.keys(question_answer_key_array).length">Next Question</button> 
							<button class="prism_btn btn_sm" v-on:click.prevent=" submit()" v-else-if="page*limit >=  Object.keys(question_answer_key_array).length">Save & Continue</button>
						</div>
					</div> 
				</div>
				<div class="row" v-if="test_failed == 1">
					<div class="col-12">
						<div class="p-5 text-center">
							<div class="thumb mb-3">
								<img src="../../../../static/fxView/images/test_failed.svg" alt="Test Failed"  width="220">
							</div>
							<h3>Appropriate test failed</h3>
							<p>Based on the answers you provided and our assessment in relation to your experience with trading leveraged products, we believe that it may not be appropriate for you to trade on a Live account at this time. Therefore, we strongly recommend that you learn more about trading CFDs and the risks involved and try to set up a Live account again after 7 days. In the meantime, you can refer to free educational resources available online, and practice trading on an Fxview Demo account.</p>
						</div>
					</div>
				</div>

				<div class="row alertResult" v-if="test_failed == 2">
					<div class="col-12 text-center">
						<div class="icon mb-5">
							<img src="../../../../static/fxView/images/error.svg" alt="Lost" width="220">
						</div>
						<p class="mb-3">Based on the answers you provided and our assessment in relation to your experience with trading leveraged products, we believe that it is risky for you to open an account. However, although you marginally failed the appropriateness test, you may still proceed to open a Live account.</p>
						
						<div class="row">
							<div class="col-12">
								<div class="mobSubmit full-width border-top pt-3  mt-3 w-100">
									<a href="#" v-on:click.prevent="$parent.do_later = true;">Cancel<small> - or -</small> </a>
									<button class="prism_btn btn_sm" v-on:click.prevent="riskFunc()">Proceed</button>
								</div>
							</div>
						</div>
					</div>
				</div>
		
			</div>
		</div>
			
		</div>
	</div>
</template>
<script>
	import * as types from '@/types'
    import { mapActions } from 'vuex'
    import { fxViewMixins } from '@/plugins/fxView'
    export default {
        name: 'stepThree',
        mixins: [fxViewMixins],
        data() {
            return {
            	response_msg : '',
                msg_type : '',
                pageLoader : false,
				"ques_ans_array" : {},
				"step" : '3',
				"ques_ans_list" : [],
				question_answer_key_array:[],
				submitted: false,
                userCountry : 'N/A',
				show_question : 0,
				ques_id : '1',
				incWidth : 0,
				progress_bar : 0,
				test_failed : -1,
				lastSelectedQuestionId: [],
				check1: false,
				disable: false,
				page: 1,
				limit: 3,
				default_lang: 'en'
            }
        },
		methods:{
			classFunction(questionid,answerid){
				for (var i = 0; i < this.ques_ans_array.length; i++) {
					if(this.ques_ans_array[i] && this.ques_ans_array[i].question_id == questionid && this.ques_ans_array[i].ans_id == answerid){
						return 'selected'
					} 
				}
				return ''
			},
			selectId(getId){
				this.ques_id = getId
			},
			startTestEvent(){
				this.$trackEvent('CP+Client+Verification+3+Start')
			},
			riskFunc(){
                let user_json = this.get_user
				user_json.step = 3
				this.$store.commit(types.SET_STATE, user_json)	
				localStorage.setItem('user', btoa(JSON.stringify(user_json)))
				this.$router.push('/step4')
            },
			closeModalFunc(){
				this.$parent.$parent.showStepComponent = false
			},
			selectedAnswer(questionid, answerid){
				for (var i = 0; i < this.ques_ans_array.length; i++) {
					
					if(this.ques_ans_array[i] && this.ques_ans_array[i].question_id == questionid && this.ques_ans_array[i].ans_id == answerid){
						return true
					} 
				}
				return false
			},
			...mapActions({
                _runRegisterStepThree: types.RUN_REGISTER_STEP3,
				_runGetQuestionAnswer: types.RUN_GET_QUESTION_ANSWER,
                _runGetUserIp: types.RUN_GET_USER_IP
            }),
            quesNext(key){
				this.$trackEvent('CP+Client+Verification+3+Next')
				this.$trackEvent('CP+Client+Verification+4+Pageview')
            	let _that = this
            	this.$validator.validate().then(valid => {
            		if(valid){
            			_that.page += 1
            		}
            		/*if(this.ques_ans_array[key]){
            			_that.show_question += 1 
            		}*/
            	});
            },
            next(questionid){
            	for (var i = 0; i < this.ques_ans_array.length; i++) {
					if(this.ques_ans_array[i] && this.ques_ans_array[i].question_id == questionid){
						
						this.lastSelectedQuestionId.push(questionid)

						this.show_question = parseInt(this.show_question) + 1
		            	this.incWidth += 10
		            	this.progress_bar += 10
		            	
					} 
				}
            },
            back(){
            	let questionid = this.lastSelectedQuestionId.pop()
            	for (var i = 0; i < this.ques_ans_array.length; i++) {
					if(this.ques_ans_array[i] && this.ques_ans_array[i].question_id == questionid){
						
						this.show_question = parseInt(this.show_question) - 1
		            	this.incWidth -= 10
		            	this.progress_bar -= 10
		            	
					} 
				}
            },
			submit(){
				this.$trackEvent('CP+Client+Verification+4+Next')
				if(this.disable){
                    let currentStep = this.get_user.step

                    if('tempStep' in this.get_user && currentStep < this.get_user.tempStep){
                        currentStep = this.get_user.tempStep
                    }
                    this.get_user.tempStep = currentStep
                    this.get_user.step = 4
                    let user_json = this.get_user
                    this.$store.commit(types.SET_STATE, user_json)
                }else{
					delete this.ques_ans_array[0]
					let ques_ans_array = []
					for(const key in this.ques_ans_array){
						if(this.question_answer_key_array[key]){
							this.question_answer_key_array[key].answers.forEach(val=>{
								if(val.ans_id == this.ques_ans_array[key]){
									let d = {...val}
									d.type = this.question_answer_key_array[key].type
									ques_ans_array.push(d)
								}
							})
						}
					}
					const _that = this
					_that.submitted = true;
					_that.$validator.validate().then(valid => {
						if (valid) {
							let input_json={
								'globalParams' :{
									'ques_ans_array': ques_ans_array,
									'step' : _that.step,
                                    "ip_country": this.userCountry
								},
								'localParams' :{
									"parameter" : _that
								}
							}
							_that._runRegisterStepThree(input_json)
						}else{
							//_that.handleValidationErrorAdvanced(_that.errors)
						}
					});
				}
			},
			getSelectedLanguage(){
				if(localStorage.getItem('lang')){
					if(localStorage.getItem('lang') == 'Spanish'){
						return 'es';
					}else if(localStorage.getItem('lang') == 'English'){
						return 'en'; 
					}else if(localStorage.getItem('lang') == 'Portuguese'){
						return 'pt'; 
					}
				} else {
					return 'en'; 
				}
			},
			trackFzEvent(eventName){
				switch(eventName){
					case 1:
						this.$trackEvent('CP+Client+Verification+3+Share+Trades');
					break;
					case 2:
						this.$trackEvent('CP+Client+Verification+3+Futures+Trades');
					break;
					case 3:
                        this.$trackEvent('CP+Client+Verification+3+FX+Trades');
					break;
					case 4:
                        this.$trackEvent('CP+Client+Verification+4+Experience');
					break;
					case 5:
                        this.$trackEvent('CP+Client+Verification+4+CFD+Loss');
					break;
					case 6:
                        this.$trackEvent('CP+Client+Verification+4+Lose+Deposit');
					break;
				}
			},
			trackPrevEvent(){
				this.$trackEvent('CP+Client+Verification+3+Back')
			}
		},
		created(){
			this.$trackEvent('CP+Client+Verification+3+Pageview')
			const _that = this
            this._runGetUserIp({'globalParams' :{},'localParams' :{ "parameter" : this } })
			_that._runGetQuestionAnswer({
				'globalParams' :{
					question_lang: _that.getSelectedLanguage(),
				},
				'localParams' :{
					"parameter" : _that
				}
			})
			if(parseInt(this.get_user.profile.ipv_status)){
                this.disable = true;
                alert(1)
            }
			window.setTimeout(_that._runGetUserRegisterationStepData({'globalParams' :{},'localParams' :{ "parameter" : _that , "step" : '3'}}), 5000)
		}
    }
</script>
<style scoped>
	.form-control:disabled, .form-control[readonly]{
		opacity: 0 !important;
	}
</style>


// WEBPACK FOOTER //
// src/components/fxView/registerSteps/step3.vue